import { mapState } from 'vuex';

export const isExternalUser = {
  computed: mapState({
    isExternalUser: state => !!state.auth.data?.externalId
  })
};
